var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.size),function(item,i){return _c('li',{key:i},[_c('span',[_vm._v(_vm._s(_vm.infoKeys[i])+" : ")]),_c('span',[_vm._v(" "+_vm._s(_vm.infoValue1[i]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }